import { render, staticRenderFns } from "./IconSchedule.vue?vue&type=template&id=23a09372&"
import script from "./IconSchedule.vue?vue&type=script&lang=ts&"
export * from "./IconSchedule.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports